import React from 'react';
import Translate from '../../../../core/translate/Translate';
import { withNotifications } from '../../../common/notifications/NotificationsContext';

const BelowTheLineIncentive = ({ incentive, notifications }) => {
  const { show } = notifications;
  const onOpenDisclosure = (event) => {
    event.preventDefault();
    show(incentiveDisclaimers, event);
  };

  let incentiveDisclaimers = '';

  incentive.disclaimers.map(
    (disclaimer) => (incentiveDisclaimers += disclaimer + '<br>')
  );

  return (
    <div className="below-line-incentive">
      <div className="below-line-incentive__program">{incentive.program}</div>
      {incentiveDisclaimers ? (
        <button className="incentive__disclosure" onClick={onOpenDisclosure}>
          <span
            className="below-line-incentive__amount"
            dangerouslySetInnerHTML={{ __html: incentive.amount.text }}
          />
          <span className="incentive__disclaimer-dagger">†</span>
        </button>
      ) : (
        <div
          className="below-line-incentive__amount"
          dangerouslySetInnerHTML={{ __html: incentive.amount.text }}
        />
      )}
    </div>
  );
};

const BelowTheLineIncentives = ({
  pricing: { belowTheLineIncentives },
  notifications,
}) => {
  const incentives = belowTheLineIncentives.map((incentive, index) => (
    <BelowTheLineIncentive
      key={index}
      incentive={incentive}
      notifications={notifications}
    />
  ));

  if (belowTheLineIncentives.length < 1) return null;

  return (
    <div className="below-line-incentives">
      <div className="below-line-incentives__header">
        <Translate value="below.line.incentives.header.v3" />
      </div>
      <div className="below-line-incentives__grid">{incentives}</div>
    </div>
  );
};

export default withNotifications(BelowTheLineIncentives);
